module.exports = __webpack_public_path__ + "img/glass-shoe.5677656f.png";